
import _ from 'lodash';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { AppNavbar, AppHeader } from '@returns-centre/components';

@Component({
    components: {
        AppNavbar,
        AppHeader
    }
})
export default class AppPage extends Vue {
    @Prop({ default: false }) requiresHeader!: boolean;
    @Prop({ default: false }) requiresFooter!: boolean;
    @Prop({ default: true }) requiresBorder!: boolean;
    @Prop({ default: true }) requiresNavigation!: boolean;
    @Prop({ default: false }) requiresBanner!: boolean;
    @Prop({ default: false }) requiresAccordion!: boolean;
    @Prop({ default: false }) shorten!: boolean;

    @Prop() rounded!: boolean;
}
